import * as Auth from '/b2b/authentication/state/Auth.selectors';

import { REPORTS, TODOS } from '../constants';

export {
    getData,
    getError,
    getPreferences,
    getSelectedDomain,
    getStore,
    isLoading,
} from './Dashboard.store';

const isResourceAllowed = (state, { customerPermission, rolePermission }) => {
    // If neither permission is defined, deny access
    if (!customerPermission && !rolePermission) {
        return false;
    }

    // Check both permissions if they exist
    const hasCustomerPermission = customerPermission
        ? Auth.customer.hasPermission(state, customerPermission)
        : true;

    const hasRolePermission = rolePermission
        ? Auth.user.hasPermission(state, rolePermission)
        : true;

    // If both permissions exist, both must pass; otherwise, the existing one must pass
    return hasCustomerPermission && hasRolePermission;
};

const getAllowedResources = (state, resources) =>
    Object.fromEntries(
        Object.entries(resources).filter(([_, resource]) => isResourceAllowed(state, resource))
    );

export const getAllowedReports = state => getAllowedResources(state, REPORTS);
export const getAllowedTodos = state => getAllowedResources(state, TODOS);
/**
 * Most to-dos stay listed at a count of zero, so the list can show the work as done. One that
 * sets `hideWhenZero` drops off the list instead, for counts that only matter when non-zero.
 * @param {string} todo The to-do key, as returned by the API
 * @param {number} count The count the API reported for it
 * @returns {boolean} Whether the to-do belongs in the list at that count
 */
export const isTodoListed = (todo, count) => !(TODOS[todo]?.hideWhenZero && !count);

export const getFilteredTodos = (state, todos = {}) =>
    Object.fromEntries(
        Object.entries(todos)
            .map(([product, productTodos]) => {
                const filteredTodos = Object.fromEntries(
                    Object.entries(productTodos).filter(
                        ([todo, count]) =>
                            isResourceAllowed(state, TODOS[todo] || {}) && isTodoListed(todo, count)
                    )
                );

                return [product, filteredTodos];
            })
            .filter(([, filteredTodos]) => Object.keys(filteredTodos).length > 0)
    );
